import { React, useEffect, useState } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import "./SignIn.css"
import { BASE_URL } from "../../config"
import axios from "axios"
import Logo from "../../assets/images/cftLogo.svg"
import googleIcon from "../../assets/images/googleIcon.svg"
import fbIcon from "../../assets/images/fbIcon.svg"
import appleIcon from "../../assets/images/appleIcon.svg"
import loginImg from "../../assets/images/loginImg.png"

import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid'
import authStorage from "../../utils/authStorage";

import { GoogleOAuthProvider, GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import AppleLogin from "react-apple-login";

const GOOGLE_CLIENT_ID = "764716966644-mra0j78knqbib9fpehcngjjt9lh4eell.apps.googleusercontent.com";
const APPLE_CLIENT_ID = "com.cftconnect.web"; // e.g. com.example.web
const APPLE_REDIRECT_URI = "https://newapp.contingentfitness.com/"; // Must match in Apple Developer

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [resStatus,setResStatus]=useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginSubmit = () => {
    setLoading(true);
    axios({
      url: `${BASE_URL}/auth/signin`,
      method: "POST",
      data: { email, password },
    })
      .then((res) => {
        setLoading(false);
        setResStatus(res?.status);
        let data = res?.data?.data;
        storeUserData(data);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          setError(err?.response?.data?.message);
          setResStatus(err?.response?.status);
          setTimeout(() => {
            setError("");
          }, 3000);
        }
        setLoading(false);
      });
  };

  const storeUserData = (data) => {
	authStorage.setItem('walkthough', JSON.stringify({ walkThroughPending: data?.walkThroughPending, walkThroughSteps: data?.walkThroughSteps }));
	authStorage.setItem('auth-token', data?.accessToken);
	authStorage.setItem('company', data?.company ? JSON.stringify(data?.company) : "");
	authStorage.setItem('user', JSON.stringify({ price: data?.price, userCount: data.userCount, userRange: data?.userRange, expectedCftUser: data?.expectedCftUser }));
	authStorage.setItem('roles', data?.roles);
	authStorage.setItem('user-name', (data?.firstName || data?.companyName) + ' ' + (data?.lastName || ''));
	authStorage.setItem('email', data?.email);
	authStorage.setItem('subscribedStatus', data?.subscribedStatu || false);
	authStorage.setItem('planType', data?.planType || '');
	authStorage.setItem('coupon', data?.coupon || '');
	authStorage.setItem('status', data?.status || '');
	
	//console.log(localStorage); return;

    setTimeout(() => {
      if (data?.walkThroughPending && data?.walkThroughSteps === "0") {
        if (data?.roles === "user" && data?.company?.email) {
          navigate("/device");
        } else {
          if (
            !data.hasOwnProperty("personInCharge") ||
            data.personInCharge.trim() === ""
          ) {
            navigate("/membership");
          } else {
            navigate("/device");
          }
        }
      } else if (data?.walkThroughPending && data?.walkThroughSteps === "1") {
        navigate("/device");
      } else {
        navigate("/device");
      }
    }, 200);
  };
  
  /*const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const token = credentialResponse.credential;
		const res = await axios.post(`${BASE_URL}/auth/signupWithGoogle`, { 
			'idToken': token, 
			'isGConnect': 1,
			'fromWebApp': 1,
			'clientId': GOOGLE_CLIENT_ID,
		});
      storeUserData(res.data.data);
    } catch (error) {
      console.error("Google login backend error", error);
    }
  };
  */
  
  const googleLogin = useGoogleLogin({
		onSuccess: async (tokenResponse) => {
		console.log('Google Login Success:', tokenResponse);

		// Example: fetch user info
		const userInfo = await axios.get(
		'https://www.googleapis.com/oauth2/v3/userinfo',
		{ headers: { Authorization: `Bearer ${tokenResponse.access_token}` } }
		);
		console.log('User Info:', userInfo.data);
		// You can now send userInfo.data to your backend
	  
		try {
			const res = await axios.post(`${BASE_URL}/auth/signupWithGoogle`, { 
				'accessToken': tokenResponse.access_token, 
				'isGConnect': 1,
				'fromWebApp': 1,
				'clientId': GOOGLE_CLIENT_ID,
			});
			storeUserData(res.data.data);
		} catch (error) {
			console.error("Google login backend error", error);
		}
    },
    onError: () => {
      console.log('Google Login Failed');
    },
    flow: 'implicit', // or 'auth-code' depending on your backend
  });

  const handleAppleSuccess = async (response) => {
    try {
      // response.authorization.id_token is the JWT
      console.log("Apple login response:", response);
      const idToken = response.authorization?.id_token;
      const code = response.authorization?.code;

      // userId from decoded id_token
      let userId = null;
      let firstName = null;
      let lastName = null;

      if (idToken) {
        const payload = JSON.parse(atob(idToken.split('.')[1]));
        userId = payload.sub;
        firstName = response.user.name.firstName;
        lastName = response.user.name.lastName;
      }

      // Only present on first login:
      const fullName = response?.user?.name
        ? `${response.user.name.firstName} ${response.user.name.lastName}`
        : null;
      const email = response?.user?.email || null;

      console.log('Apple ID Token:', idToken);
      console.log('Apple User ID:', userId);
      console.log('Apple Full Name:', fullName);
      console.log('Apple Email:', email);

      if (!idToken || !code) {
        console.error("Missing id_token or code in Apple response");
        return;
      }

      const res = await axios.post(`${BASE_URL}/auth/signupWithApple`, { 
        idToken,
        'isAConnect': 1,
        'fromWebApp': 1,
        'givenName': firstName,
        'familyName': lastName,
        'email': email,
        'userIdentifier': userId
      });
      
      storeUserData(res.data.data);
    } catch (error) {
      console.error("Apple login backend error", error);
    }
  };
  
  useEffect(() => {
    let isLogin = authStorage.getItem("auth-token");
    if (!isLogin && !(location.pathname === '/' || location.pathname === '/sign-up')) {
      navigate('/');
    } else if (isLogin && location.pathname === "/") {
      navigate('/device');
    }
  }, [location]);
  return (
	<>
	  <style>
        {`
          .sign-in-default .container .continue-line::after,
          .sign-in-default .container .continue-line::before {
            background-color: #08103c;
            content: "";
            height: 1px;
            position: absolute;
            top: 10px;
            width: 95px;
          }
        `}
      </style>
	  
      <div className="sign-in-page sign-in-default sign-in-default-v1">
        {/* <div className="bg-icons" /> */}
        <div className="container">
          <div className="form-box-outer">
            <div className="content-block">
              <div className="logo">
                <img src={Logo} alt="logo" />
              </div>
              <h1>Log in to</h1>
              <p>CFT is a fitness tracker-based App that provides all the necessary components to help individuals and employees become healthy.</p>
            </div>
            <div className="form-box">
              <h2>Login</h2>
              <div className="input-box">
                <label>Email Address</label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  id="email-address"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  placeholder="Email address"
                />
                {resStatus===404&&( <span className="error">{error}</span>)}
               
              </div>
              <div className="input-box">
                <label>Password</label>
                <div className="relative">
                  <input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    id="password"
                    name="password"
                    type={!showPassword?'password':"text"}
                    autoComplete="current-password"
                    required
                    placeholder="Password"
                  />
                  <span className="input-icon" onClick={()=>{setShowPassword(!showPassword)}} >
                    {!showPassword?<EyeSlashIcon class="h-5 w-5 text-gray-300" />: <EyeIcon class="h-5 w-5 text-gray-300" />}
                  </span>
                </div>
                {resStatus===401&&( <span className="error">{error}</span>)}
              </div>
              <div className="link-box">
                <Link to="/forgot/password">Forgot Passowrd ?</Link>
              </div>
              <div className="submit-box">
                <button onClick={() => handleLoginSubmit()} type="button" className="">
                  {loading ? (<div className="lds-facebook"><div></div><div></div><div></div><div></div><div></div></div>) : "Login"}
                </button>
              </div>
              {/* <div className="continue-line">or continue with</div>
              <div className="social-media">
                <Link to="">
                  <img src={fbIcon} alt="Icon" />
                </Link>
                <Link to="/">
                  <img src={googleIcon} alt="Icon" />
                </Link>
              </div> */}
			  
			  <div className="continue-line">or continue with</div>
			  <div className="social-media">
                {/* ✅ Google Sign In */}
                {/* <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={() => console.log("Google Login Failed")}
				  text="signin"
                /> */}
				<button
					onClick={() => googleLogin()}
					style={{
					  backgroundColor: 'transparent',
					  color: '#000',
					  border: 'medium',
					  cursor: 'pointer',
					  fontSize: '14px',
					  padding: '8px 16px',
					  display: 'flex',
					  alignItems: 'flex-end',
					  border: '1px solid #dbd2d2',
					  borderRadius: '4px',
					}}
				  >
					<img src={googleIcon} width="18" alt="Icon" /> &nbsp; Sign in
				</button>

                {/* ✅ Apple Sign In */}
                <AppleLogin
                  clientId={APPLE_CLIENT_ID}
                  redirectURI={APPLE_REDIRECT_URI}
                  responseType="code id_token"
                  responseMode="form_post"
                  scope="name email"
                  usePopup={true}
                  callback={handleAppleSuccess}
                  render={(props) => (
                    <button
                      onClick={props.onClick}
                      style={{
                        backgroundColor: "#000",
                        color: "#fff",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        marginLeft: "8px",
						display: "flex",
						alignItems: "flex-end",
                      }}
                    >
                      <img src={appleIcon} width="18" alt="Icon" /> &nbsp; Sign in
                    </button>
                  )}
                />
              </div>
			  
              <div className="bottom-text text-center">
                Don’t have an account ? <Link to="/sign-up">Signup  </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
	</>
	)
}
export default SignIn;